/**
 * SANCTALE mild smooth scroll (desktop wheel only).
 * Progressive: no-op when JS fails, reduced motion, or coarse pointers.
 * Does not intercept keyboard, touch, or scrollbar dragging.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(pointer: fine)');
  const EASE = 0.18;
  const MAX_STEP = 120;

  let current = window.scrollY;
  let target = window.scrollY;
  let running = false;
  let active = false;

  const docMax = () =>
    Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

  const clamp = (value) => Math.min(docMax(), Math.max(0, value));

  const stop = () => {
    running = false;
  };

  const frame = () => {
    if (!active) {
      stop();
      return;
    }

    const delta = target - current;
    if (Math.abs(delta) < 0.35) {
      current = target;
      window.scrollTo(0, current);
      stop();
      return;
    }

    current += delta * EASE;
    window.scrollTo(0, current);
    running = true;
    requestAnimationFrame(frame);
  };

  const onWheel = (event) => {
    if (!active || event.ctrlKey) return;

    // Keep native behavior for nested scroll areas.
    let node = event.target;
    while (node && node !== document.body) {
      if (node instanceof HTMLElement) {
        const style = window.getComputedStyle(node);
        const canScroll =
          /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
        if (canScroll) {
          const atTop = event.deltaY < 0 && node.scrollTop <= 0;
          const atBottom =
            event.deltaY > 0 && node.scrollTop + node.clientHeight >= node.scrollHeight - 1;
          if (!atTop && !atBottom) return;
        }
      }
      node = node.parentElement;
    }

    event.preventDefault();
    target = clamp(target + Math.max(-MAX_STEP, Math.min(MAX_STEP, event.deltaY)));
    if (!running) {
      running = true;
      requestAnimationFrame(frame);
    }
  };

  const syncFromNative = () => {
    if (running) return;
    current = window.scrollY;
    target = window.scrollY;
  };

  const enable = () => {
    if (reduceMotion.matches || !finePointer.matches) {
      if (active) {
        window.removeEventListener('wheel', onWheel);
        active = false;
        stop();
      }
      return;
    }

    if (active) return;
    active = true;
    current = window.scrollY;
    target = window.scrollY;
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('scroll', syncFromNative, { passive: true });
  };

  const onChange = () => enable();

  if (typeof reduceMotion.addEventListener === 'function') {
    reduceMotion.addEventListener('change', onChange);
    finePointer.addEventListener('change', onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enable, { once: true });
  } else {
    enable();
  }
})();
